import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';

export function MainLayout() {
  return (
    <div className="flex h-screen flex-col">
      <Header />
      <main className="flex-1 overflow-y-auto bg-white p-4 sm:p-6 lg:px-14">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
